/**
 * Preview of the link card — what WhatsApp, Telegram or Slack will show.
 *
 * It reads the same `imagemSocial` the renderer uses, so what is on screen is
 * what the crawler will pick. Whoever writes the description has no way to
 * picture how it gets cropped inside a messaging app, and the description is
 * usually the last thing anyone checks before sending the link to three
 * thousand schools.
 */

import { imagemSocial, type PaginaLanding } from '@egba-do/shared'

const URL_API = import.meta.env.VITE_API_URL ?? ''

export function CartaoCompartilhamento({ pagina }: { pagina: PaginaLanding }) {
  const foto = imagemSocial(pagina)
  const titulo = pagina.seo.titulo || pagina.titulo
  const descricao = pagina.seo.descricao ?? ''
  const dominio = URL_API.replace(/^https?:\/\//, '').replace(/\/.*$/, '')

  return (
    <div className="max-w-sm overflow-hidden rounded-xl border border-[color:var(--color-borda)] bg-white">
      {foto ? (
        <img
          src={`${URL_API}${foto.url}${foto.url.includes('?') ? '' : '?l=800&f=jpeg'}`}
          alt={foto.alt}
          className="aspect-[1.91/1] w-full object-cover"
        />
      ) : (
        <div className="flex aspect-[1.91/1] w-full items-center justify-center bg-slate-100 text-center text-xs text-slate-400">
          Sem imagem — o card sai pequeno e sem foto.
          <br />
          Coloque uma imagem no destaque.
        </div>
      )}
      <div className="space-y-1 p-3">
        <p className="text-[11px] tracking-wide text-slate-400 uppercase">{dominio}</p>
        <p className="line-clamp-2 text-sm font-semibold text-slate-900">{titulo}</p>
        <p className="line-clamp-2 text-xs text-slate-500">
          {descricao || 'Sem descrição — o aplicativo vai mostrar um trecho qualquer da página.'}
        </p>
      </div>
    </div>
  )
}
